import React from 'react';

import vrcLogo from '../../assets/vrc-logo.PNG';

import classes from './logo.css'

const logo=(props)=>(
    
    <div className={classes.Logo} style={{height:props.height}}>
    <img src={vrcLogo} alt='MyBurger'/>
    </div>

);

export default logo;

//NOTE: you can't just put the file path to src property, because when we publish our app, the src folder won't be transfered to the server. But importing the image will tell React we are using the logo here and that will work.


// WEBPACK FOOTER //
// ./src/components/Logo/logo.js